export default __webpack_public_path__ + "static/media/profile_img.869e15f3.jpg";